import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import CompetitorRateForm from './CompetitorRateForm'
import { updateCompetitorRate } from '../services'
import { handleError } from '../../../helpers'

export default function EditCompetitorRateModal({ visible, onClose, reload, competitorRate }) {
	const { register, handleSubmit, formState: { errors }, reset, watch } = useForm()

	const onSubmit = values => {
		updateCompetitorRate(competitorRate.id, values)
			.then(() => {
				message.success('Tarifa actualizada exitosamente.')
				reset()
				reload()
				onClose()
			})
			.catch(error => handleError(error))
	}	

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Tarifa de Competidor</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<CompetitorRateForm 
							register={register} 
							errors={errors} 
							watch={watch}
							competitorRate={competitorRate} 
						/>
						<Button type="submit" color="primary">Actualizar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}